import React from "react";
import "./contato.css";

function Contato() {
  return (
    <section id="contato" className="contato-section">
      <div className="container">

        {/* TÍTULO */}
        <div className="titulo-bloco text-center">
          <h2>Contato</h2>
          <span className="linha-destaque mx-auto"></span>
          <p className="contato-subtitulo">
            Entre em contato para orientações, correções e apoio técnico em Engenharia Civil.
          </p>
        </div>

        <div className="row justify-content-center">

          {/* CARD CONTATO */}
          <div className="col-md-10 col-lg-8">
            <div className="contato-card">
            

              {/* TELEFONE */}
              <div className="contato-item">
                <i className="fa fa-phone"></i>
                <div>
                  <h5>Telefone / WhatsApp</h5>
                  <a href="https://wa.me/5563992528817" target="_blank" rel="noopener noreferrer">
                    (63) 99249-4311 – Eng. Jucivan Ferreira
                  </a>
                </div>
              </div>


              {/* REDES */}
              <div className="contato-redes">
                <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <i className="fa fa-instagram"></i>
                </a>
              </div>

            </div>
          </div>

        </div>

      </div>
    </section>
  );
}

export default Contato;
